import React, {useState} from "react";
import associateServices from "../../../../services";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import {toast} from "react-toastify";
import InformationToast from "../../../../components/toast/InformationToast";
import store from "../../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../../actions/authentication-actions";

const BonusRedeemModal = () => {
    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [bonusRedeem, setBonusRedeem] = useState('')


    const handleDropRedeem = () => {

        if (loading || !bonusRedeem)
            return true

        setLoading(true)

        associateServices.redeemBonus({code: bonusRedeem}).then(res => {
            setLoading(false)
            if (res?.status !== 200)
                return toast(<InformationToast
                    icon={'ti-x'}
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.errors}`)}
                />)

            const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))

            associateServices.getWallets({}).then(handleUserWallets)

            return toast(<InformationToast
                icon={'ti-check'}
                title={t(`general.information`)}
                message={t(`api-notifications.${res?.data}`)}
            />)
        })
    }


    return (
        <div>
            <div
                className="form__group d-flex flex-column align-items-center justify-content-center flex-wrap gap-4">

                <input
                    value={bonusRedeem}
                    onChange={e => setBonusRedeem(e.target.value)}
                    type="text" className="form__input"/>

                <FormButton
                    onClick={handleDropRedeem}
                    label={t('settings.offers.drop.submit')}
                    loading={loading}
                    disabled={loading}
                />

            </div>


        </div>
    )

}


export default BonusRedeemModal
